// Zentrale Inhalte der Website — hier können Name, Links, Bio und Vita einfach ausgetauscht werden.

export const PROFILE = {
  name: "Clive Bucher",
  firstName: "Clive",
  lastName: "Bucher",
  role: "Schauspieler",
  tagline: "Film · TV · Werbung · Stimme",
  location: "Zürich, Schweiz",
  email: "bucherclive@gmail.com",
  phone: "+41 78 649 91 19",
};

export const LINKS = {
  instagram: "https://instagram.com/clivebucher",
  tiktok: "https://tiktok.com/@clive_bucher",
  imdb: "https://imdb.me/clivebucher",
  linkedin: "https://www.linkedin.com/in/clive-bucher-800a131b1/",
  reel: "https://youtu.be/aKAy9oR7X54",
};

export const REEL_ID = "aKAy9oR7X54";

export const IMAGES = {
  portrait: "https://customer-assets-39nsmqrw.emergentagent.net/job_headshot-hub-54/artifacts/sop25r4l_Kleiner%20MB%202.webp",
  editorial: "https://customer-assets-39nsmqrw.emergentagent.net/job_headshot-hub-54/artifacts/bk1eb2d4_Kleiner%20MB%203.webp",
  reelThumb: "https://img.youtube.com/vi/aKAy9oR7X54/maxresdefault.jpg",
  fullbodyStreet: "https://customer-assets-39nsmqrw.emergentagent.net/job_headshot-hub-54/artifacts/7cus3rz1_DSC09126.webp",
  fullbodyStudio: "https://customer-assets-39nsmqrw.emergentagent.net/job_headshot-hub-54/artifacts/t4tz2alu_DSC09073.webp",
  contactBg: "https://images.unsplash.com/photo-1669277752825-d7c26a392b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxtb29keSUyMGNpbmVtYXRpYyUyMG1hbGUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODU1OTM1MTZ8MA&ixlib=rb-4.1.0&q=85",
};

export const HEADSHOTS = [
  { src: IMAGES.portrait, label: "Portrait", span: "lg:col-span-7", ratio: "aspect-[4/5]" },
  { src: IMAGES.editorial, label: "Editorial", span: "lg:col-span-5", ratio: "aspect-[4/5]" },
  { src: IMAGES.fullbodyStreet, label: "Ganzkörper", span: "lg:col-span-5", ratio: "aspect-[3/4]" },
  { src: IMAGES.fullbodyStudio, label: "Studio", span: "lg:col-span-7", ratio: "aspect-[3/4]" },
  { src: IMAGES.reelThumb, label: "On Set", span: "lg:col-span-12", ratio: "aspect-[21/9]" },
];

export const VIDEO_LINKS = [
  { key: "instagram", href: LINKS.instagram, img: IMAGES.editorial },
  { key: "tiktok", href: LINKS.tiktok, img: IMAGES.reelThumb },
];

export const CHAPTERS = [
  {
    nr: "01",
    title: "Herkunft",
    text: "Aufgewachsen in Schweizer Heimen, hat Clive Bucher seinen Weg selbst gebaut — bis vor ein nationales TV-Publikum. Dieser unkonventionelle Weg prägt die Widerstandskraft, Disziplin und emotionale Tiefe, die er in jede Rolle bringt.",
  },
  {
    nr: "02",
    title: "Handwerk",
    text: "Schauspieltraining in Los Angeles: On-Camera Acting, Scene Study, Audition- und Commercial-Technik. Vor der Kamera: Serien-Hauptrolle in «The Bachelor Schweiz» 2018 sowie Spots und Kampagnen für Yallo, Click & Care und Best Smile.",
  },
  {
    nr: "03",
    title: "Haltung",
    text: "Unternehmer, Speaker und Autor des Buchs «Mental Power». Wer selbst eine Firma gegründet und geführt hat, spielt Führung nicht — er kennt sie: ambitionierte Leader, Unternehmer, Ermittler, Anwälte und Action-Charaktere mit emotionaler Zugänglichkeit.",
  },
];

export const VITA = {
  stats: [
    { label: "Grösse", value: "192 cm" },
    { label: "Spielalter", value: "27–35" },
    { label: "Sprachen", value: "Deutsch · Mundart · Englisch · Spanisch" },
    { label: "Haar / Augen", value: "Braun / Grün-Grau" },
  ],
  film: [
    { year: "2018", role: "Series Lead (Hauptrolle)", production: "The Bachelor Schweiz", director: "Warner Bros.", type: "TV-Serie" },
  ],
  commercial: [
    { year: "—", role: "Principal", production: "Yallo", director: "", type: "TV-Spot" },
    { year: "—", role: "Principal", production: "Click & Care", director: "", type: "TV-Spots" },
    { year: "—", role: "Principal", production: "Best Smile", director: "", type: "Digitalkampagne" },
    { year: "—", role: "Principal", production: "Bucher Invest", director: "", type: "Digitalkampagne" },
  ],
  theater: [
    { year: "—", role: "Levi", production: "Crazy Girlfriend", director: "TCE Theater", type: "Bühne" },
  ],
  training: [
    { year: "LA", role: "Scene Study · On-Camera · Partner Work", production: "Berg Studios", director: "", type: "Training" },
    { year: "LA", role: "Scene Study", production: "Alice's Studio for Actors", director: "", type: "Training" },
    { year: "LA", role: "Scene Study · Cold Reading", production: "Tanya Chisholm", director: "", type: "Training" },
    { year: "LA", role: "On-Camera · Improv", production: "Jay Reid", director: "", type: "Training" },
    { year: "LA", role: "Audition Technique", production: "Omar Morris", director: "", type: "Training" },
    { year: "LA", role: "Commercial Technique", production: "Helena Assis", director: "", type: "Training" },
  ],
  skills: ["Thai Boxing", "Boxen", "Eishockey", "Tennis", "Ski & Snowboard", "Fussball", "Krafttraining", "Schwimmen", "Open Water Diving", "Motorrad", "Motorboot-Schein", "Salsa / Streetdance", "Public Speaking", "Autor «Mental Power»"],
};

export const STATEMENTS = [
  { text: "192 cm Präsenz — gemacht für Führungsfiguren, Unternehmer, Ermittler, Anwälte und Einsatzkräfte.", source: "Physisches Profil" },
  { text: "Serien-Hauptrolle «The Bachelor Schweiz» 2018 — nationale TV-Reichweite, produziert von Warner Bros.", source: "TV-Erfahrung" },
  { text: "Unternehmer, Speaker und Autor von «Mental Power» — Führung und Hochdruck-Entscheidungen aus erster Hand.", source: "Jenseits der Kamera" },
];

export const CHAPTERS_EN = [
  { nr: "01", title: "Origins", text: "Raised in Swiss care institutions, Clive Bucher built his own path — all the way to a national television audience. That unconventional journey shapes the resilience, discipline and emotional depth he brings to every role." },
  { nr: "02", title: "Craft", text: "Trained in Los Angeles in on-camera acting, scene study, audition and commercial technique. On screen: series lead of «The Bachelor Switzerland» 2018, plus spots and campaigns for Yallo, Click & Care and Best Smile." },
  { nr: "03", title: "Drive", text: "Entrepreneur, speaker and author of the book «Mental Power». Having founded and led his own company, he does not play leadership — he knows it: ambitious leaders, entrepreneurs, investigators, lawyers and action-driven characters with emotional accessibility." },
];

export const STATEMENTS_EN = [
  { text: "192 cm of presence — built for leaders, entrepreneurs, investigators, lawyers and law-enforcement characters.", source: "Physical profile" },
  { text: "Series lead of «The Bachelor Switzerland» 2018 — national TV reach, produced by Warner Bros.", source: "Television" },
  { text: "Entrepreneur, speaker and author of «Mental Power» — leadership and high-pressure decisions first-hand.", source: "Beyond the camera" },
];

export const VITA_EN = {
  stats: [
    { label: "Height", value: "192 cm (6'3\")" },
    { label: "Playing age", value: "27–35" },
    { label: "Languages", value: "German · Swiss German · English · Spanish" },
    { label: "Hair / Eyes", value: "Brown / Green-Grey" },
  ],
  film: [{ year: "2018", role: "Series Lead", production: "The Bachelor Switzerland", director: "Warner Bros.", type: "TV series" }],
  commercial: [
    { year: "—", role: "Principal", production: "Yallo", director: "", type: "TV commercial" },
    { year: "—", role: "Principal", production: "Click & Care", director: "", type: "TV commercials" },
    { year: "—", role: "Principal", production: "Best Smile", director: "", type: "Digital campaign" },
    { year: "—", role: "Principal", production: "Bucher Invest", director: "", type: "Digital campaign" },
  ],
  theater: [{ year: "—", role: "Levi", production: "Crazy Girlfriend", director: "TCE Theater", type: "Stage" }],
};

export const COPY = {
  de: {
    nav: { headshots: "Headshots", showreel: "Showreel", ueber: "Über mich", vita: "Vita", profil: "Profil", kontakt: "Kontakt" },
    hero: {
      tagline: "Film · TV · Werbung · Stimme — Zürich, Schweiz",
      intro: "Schauspieler für Film, Fernsehen und Werbung. Hier finden Castings, Agenturen und Regie Headshots, Showreel, Vita und Kontakt — alles an einem Ort.",
      discover: "Entdecken",
    },
    headings: {
      headshots: { index: "01", title: "Headshots", sub: "Porträt — aktuelle Fotos" },
      showreel: { index: "02", title: "Showreel & Videos", sub: "Bewegtbild — Reel, Reels, Behind the Scenes" },
      about: { index: "03", title: "Über mich", sub: "Manifest — in drei Kapiteln" },
      vita: { index: "04", title: "Vita", sub: "Lebenslauf — Rollen, Training, Fähigkeiten" },
      profil: { index: "05", title: "Profil", sub: "Positionierung — was Clive mitbringt" },
      kontakt: { index: "06", title: "Kontakt", sub: "Casting, Agentur, Presse — schreib mir" },
    },
    chapters: CHAPTERS,
    quote: { text: "„Mentale Stärke ist trainierbar — vor der Kamera genauso wie im Leben.“", source: "Autor von «Mental Power»" },
    videoSection: {
      youtubeLink: "Auf YouTube ansehen",
      cards: {
        instagram: { title: "Reels & Behind the Scenes", meta: "Instagram · @clivebucher" },
        tiktok: { title: "Clips & Kurzvideos", meta: "TikTok · @clive_bucher" },
      },
    },
    vita: {
      stats: VITA.stats,
      headers: { year: "Jahr", role: "Rolle", production: "Produktion", director: "Regie", format: "Format" },
      tables: [
        { key: "film", title: "Film & Fernsehen", rows: VITA.film },
        { key: "commercial", title: "Werbung & Kampagnen", rows: VITA.commercial },
        { key: "theater", title: "Theater", rows: VITA.theater },
        { key: "training", title: "Training (Los Angeles)", rows: VITA.training },
      ],
      skills: VITA.skills,
      pdfLabel: "Vita als PDF",
    },
    statements: STATEMENTS,
    contact: {
      direct: "Direkt",
      phoneLabel: "Telefon",
      availability: "Verfügbar für Film, TV, Werbung und Voice-over in der Schweiz und Europa — langfristig international.",
      profiles: "Profiles",
      links: [
        { key: "instagram", label: "Instagram — Reels" },
        { key: "tiktok", label: "TikTok — Kurzvideos" },
        { key: "imdb", label: "IMDb — Offizielles Profil" },
        { key: "linkedin", label: "LinkedIn — Netzwerk" },
      ],
      form: { name: "Dein Name", email: "E-Mail", subject: "Betreff (z. B. Casting-Anfrage)", message: "Deine Nachricht", submit: "Nachricht senden" },
      success: "Nachricht gesendet. Merci vielmal!",
      error: "Senden fehlgeschlagen. Bitte versuche es erneut oder schreib direkt per E-Mail.",
    },
    footer: { impressum: "Impressum", role: "Schauspieler", location: "Zürich, Schweiz" },
    marquee: ["Schauspiel", "Film", "TV", "Stimme", "Bewegung", "Casting"],
  },
  en: {
    nav: { headshots: "Headshots", showreel: "Showreel", ueber: "About", vita: "Resume", profil: "Profile", kontakt: "Contact" },
    hero: {
      tagline: "Film · TV · Commercial · Voice — Zurich, Switzerland",
      intro: "Actor for film, television and commercials. Casting directors, agents and filmmakers will find headshots, showreel, resume and contact — all in one place.",
      discover: "Explore",
    },
    headings: {
      headshots: { index: "01", title: "Headshots", sub: "Portrait — current photos" },
      showreel: { index: "02", title: "Showreel & Videos", sub: "On screen — reel, clips, behind the scenes" },
      about: { index: "03", title: "About", sub: "Manifesto — in three chapters" },
      vita: { index: "04", title: "Resume", sub: "Credits, training, skills" },
      profil: { index: "05", title: "Profile", sub: "Positioning — what Clive brings" },
      kontakt: { index: "06", title: "Contact", sub: "Casting, agency, press — get in touch" },
    },
    chapters: CHAPTERS_EN,
    quote: { text: "„Mental strength is trainable — in front of the camera just as in life.“", source: "Author of «Mental Power»" },
    videoSection: {
      youtubeLink: "Watch on YouTube",
      cards: {
        instagram: { title: "Reels & Behind the Scenes", meta: "Instagram · @clivebucher" },
        tiktok: { title: "Clips & Short Videos", meta: "TikTok · @clive_bucher" },
      },
    },
    vita: {
      stats: VITA_EN.stats,
      headers: { year: "Year", role: "Role", production: "Production", director: "Director", format: "Format" },
      tables: [
        { key: "film", title: "Film & TV", rows: VITA_EN.film },
        { key: "commercial", title: "Commercials", rows: VITA_EN.commercial },
        { key: "theater", title: "Theatre", rows: VITA_EN.theater },
        { key: "training", title: "Training (Los Angeles)", rows: VITA.training },
      ],
      skills: VITA.skills,
      pdfLabel: "Resume as PDF",
    },
    statements: STATEMENTS_EN,
    contact: {
      direct: "Direct",
      phoneLabel: "Phone",
      availability: "Available for film, TV, commercial and voice-over productions across Switzerland and Europe — long-term international focus.",
      profiles: "Profiles",
      links: [
        { key: "instagram", label: "Instagram — Reels" },
        { key: "tiktok", label: "TikTok — Short videos" },
        { key: "imdb", label: "IMDb — Official profile" },
        { key: "linkedin", label: "LinkedIn — Network" },
      ],
      form: { name: "Your name", email: "Email", subject: "Subject (e.g. casting enquiry)", message: "Your message", submit: "Send message" },
      success: "Message sent. Thank you!",
      error: "Sending failed. Please try again or write an email directly.",
    },
    footer: { impressum: "Imprint", role: "Actor", location: "Zurich, Switzerland" },
    marquee: ["Acting", "Film", "TV", "Voice", "Movement", "Casting"],
  },
};
